<div #printContent id="printContent">
  <button class="tourPageBtn mr-3" id="help-tour-btn" (click)="startTour()" title="Take a tour">
    <img src="/assets/images/tutorialOverlayBttn.svg" />
  </button>
  <div class="print-hide" *ngIf="showSchoolFilter">
    <wf-school-teacher-filter
      [error]="schoolFilterError"
      [districts]="districts"
      [schools]="schools"
      [teachers]="teachers"
      (filterChangeEvent)="updateStudentSessions()"
    ></wf-school-teacher-filter>
  </div>
  <div  [ngClass]="{ 'disabled-report' : schoolFilterError }"></div>
  <div class="header-controls split-flex">
    <h3>
      <fa-icon [icon]="reportsIcon"/>
      Reports
    </h3>
    <div class="print-hide filter-options">
      <wf-students-filter [grades]="grades" [classes]="classes" [filterExtraSupport]="false" (filterChangeEvent)="filterSessions($event)"></wf-students-filter>
    </div>
    <div>
      <refresh-button id="refresh-button" (click)="refreshingTableData()"></refresh-button>
      <button id="export-button" class="btn export-report-button print-hide" (click)="exportSessionSummary()" [disabled]="exportingReport">
        <fa-icon [icon]="excelIcon" *ngIf="!exportingReport"></fa-icon>
        <fa-icon [icon]="loadingIcon" [spin]="true" *ngIf="exportingReport"></fa-icon>
        Export Results
      </button>
      <button id="print-button" class="btn print-summary-button print-hide" (click)="printSummary()" *ngIf="!currentUser!.isTeacherReviewUser()"><fa-icon [icon]="printIcon"></fa-icon> Print Results</button>
      <div *ngIf="showCoTeacherFilter" class="print-hide session-coteacher-container">
        <input id="coteacher-checkbox" class="form-check-input" type="checkbox" [(ngModel)]="hideSharedStudents" (change)="onFilterCoTeacherChange()">
        <label class="form-check-label" for="coteacher-checkbox">Hide Shared Students</label>
      </div>
    </div>
  </div>
  <div>
    <div class="report-section-header split-flex">
      <h5 class="results-report-header"><fa-icon [classes]="['print-hide']" [icon]="summaryIcon"></fa-icon> Session Summary</h5>
    </div>
  </div>
  <div class="boxed-content">
    <div class="print-hide alert message alert-danger" id="export-error" *ngIf="reportError">
      <div class="icon">
        <fa-icon [icon]="errorIcon"></fa-icon>
      </div>
      <div>
        <div class="bold">Report Export Error</div>
        {{ reportError }}
      </div>
    </div>
    <div class="flex column-gap-10 margin-top-10 margin-bottom-10">
      <div id="date-controls-container" class="flex column-gap-10 width-40">
        <div id="start-date-container" class="width-50">
          <label>Start Date</label>
          <div class="input-group print-hide">
            <input class="form-control" placeholder="mm/dd/yyyy" [minDate]="minDate" [maxDate]="maxDate" ngbDatepicker #start="ngbDatepicker" [(ngModel)]="startDate" (dateSelect)="updateStudentSessions()">
            <button class="btn btn-outline-secondary calendar" (click)="start.toggle()" type="button"><fa-icon [icon]="calendarIcon"></fa-icon></button>
          </div>
          <div class="print-show">{{startDate.year}}-{{startDate.month}}-{{startDate.day}}</div>
        </div>
        <div id="end-date-container" class="width-50">
          <label>End Date</label>
          <div class="input-group print-hide">
            <input class="form-control" placeholder="mm/dd/yyyy" [minDate]="minDate" [maxDate]="maxDate" ngbDatepicker #end="ngbDatepicker" [(ngModel)]="endDate" (dateSelect)="updateStudentSessions()">
            <button class="btn btn-outline-secondary calendar" (click)="end.toggle()" type="button"><fa-icon [icon]="calendarIcon"></fa-icon></button>
          </div>
          <div class="print-show">{{endDate.year}}-{{endDate.month}}-{{endDate.day}}</div>
        </div>
      </div>
      <div id="student-wrapper" class="width-25">
        <label class="print-hide" for="student-dropdown">Student</label>
        <ng-select
          id="student-dropdown"
          class="print-hide"
          [(ngModel)]="selectedStudent"
          [clearable]="false"
          [disabled]="!canSelectStudent"
          [placeholder]="canSelectStudent ? 'All Students' : 'Select a school first'"
          (change)="onStudentChange()"
        >
          <ng-option *ngFor="let student of students" [value]="student">{{ student.firstName }} {{ student.lastName }}</ng-option>
        </ng-select>
        <div class="print-show">Student: {{ selectedStudent?.firstName || '' }} {{ selectedStudent?.lastName || '' }}</div>
      </div>
      <div id="view-wrapper" class="width-20">
        <label class="print-hide">View:</label>
        <div class="print-hide">
          <select class="form-control form-select" [(ngModel)]="viewType" (change)="handleViewChange($event)">
            <option value="sessions">Sessions</option>
            <option value="minutes">Minutes</option>
          </select>
        </div>
      </div>
    </div>
    <table class="report-table">
      <thead>
      <tr>
        <th (click)="sortTable('startDate')">
          <div class="sortable-report-table-header">
            <div>Date</div>
            <div [ngClass]=" { 'arrow-up' : !sortReverse, 'arrow-down': sortReverse }" [style.visibility]="(sortColumn !== 'startDate') ? 'hidden' : 'visible'"></div>
          </div>
        </th>
        <th (click)="sortTable('lastName')">
          <div class="sortable-report-table-header">
            <div>Student Name</div>
            <div [ngClass]=" { 'arrow-up' : !sortReverse, 'arrow-down': sortReverse }" [style.visibility]="(sortColumn !== 'lastName') ? 'hidden' : 'visible'"></div>
          </div>
        </th>
        <th *ngIf="viewType === 'sessions'">
          <div class="sortable-report-table-header">
            <div>Start Time</div>
          </div>
        </th>
        <th *ngIf="viewType === 'sessions'">
          <div class="sortable-report-table-header">
            <div>End Time</div>
          </div>
        </th>
        <th *ngIf="viewType === 'minutes'">
          <div class="sortable-report-table-header">
            <div>Minutes</div>
          </div>
        </th>
      </tr>
      </thead>
      <tbody *ngIf="viewType === 'sessions'">
      <tr *ngFor="let studentSession of filteredSessions">
        <td>{{ formatDate(studentSession.startDate) }}</td>
        <td>{{ studentSession.firstName }} {{ studentSession.lastName }}</td>
        <td>{{ formatTime(studentSession.startDate) }}</td>
        <td>{{ formatTime(studentSession.endDate) }}</td>
      </tr>
      </tbody>
      <tbody *ngIf="viewType === 'minutes'">
      <tr *ngFor="let studentSession of filteredSessionsWithSeconds">
        <td>{{ formatDate(studentSession.dateRange.startDate) }} - {{ formatDate(studentSession.dateRange.endDate) }}</td>
        <td>{{ studentSession.firstName }} {{ studentSession.lastName }}</td>
        <td>{{ roundMinutes(studentSession.seconds / 60) }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</div>
